import RestService from "@/services/RestService";

function getCalendar(start, end) {
  const data = {
    start: `${start},${end}`,
    limit: 1000,
  };
  return RestService.sendReq("get", "events", data);
}

export default {
  getCalendar,
};
